import { secondsToTimeUnits } from "../../helpers/timeHelpers";
import i18n from "../../service/i18n";

const secondsToAriaTimeFormat = ({ language, seconds }) => {
  const units = secondsToTimeUnits(seconds);
  const secondsLabel = i18n("sekuntia", { language });
  const minutesLabel = i18n("minuuttia", { language });
  const hoursLabel = i18n("tuntia", { language });
  const secondsElapsed = units.seconds
    ? `${units.seconds} ${secondsLabel}`
    : "";
  const minutesElapsed = units.minutes
    ? `${units.minutes} ${minutesLabel}`
    : "";
  const hoursElapsed = units.hours ? `${units.hours} ${hoursLabel}` : "";
  return `${hoursElapsed} ${minutesElapsed} ${secondsElapsed}`;
};

export const getTimelineAriaValueText = ({
  isLive,
  isLiveEdge,
  language,
  timeRemaining,
  timelinePosition
}: {
  isLive: boolean;
  isLiveEdge: boolean;
  language: string;
  timeRemaining?: number;
  timelinePosition: number;
}): string => {
  if (isLive && isLiveEdge) {
    return i18n("suora", { language });
  }

  if (isLive && !isLiveEdge) {
    return i18n("suoraa_lahetysta_jaljessa", {
      language
    });
  }

  const ariaFormattedElapsedProgress = secondsToAriaTimeFormat({
    language,
    seconds: timelinePosition
  });
  const ariaFormattedTimeRemaining = secondsToAriaTimeFormat({
    language,
    seconds: timeRemaining
  });

  const passedLabel = i18n("kulunut", { language });
  const leftLabel = i18n("jaljella", { language });

  return `${ariaFormattedElapsedProgress} ${passedLabel} ${ariaFormattedTimeRemaining} ${leftLabel}`;
};
